import type { ReactNode } from "react";
import { StyleSheet } from "react-native";
import { Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";

type Props = {
	title?: string;
	enableGutters?: boolean;
	children: ReactNode;
};

export const LeaderboardBox = ({
	title,
	enableGutters = true,
	children,
}: Props) => {
	const theme = useAppTheme();

	return (
		<Box
			borderColor={theme.colors.border}
			borderWidth={1}
			borderRadius={theme.roundness * 3}
		>
			{title ? (
				<Box
					paddingHorizontal={16}
					paddingVertical={12}
					borderBottomWidth={1}
					borderBottomColor={theme.colors.border}
				>
					<Text variant="bodySmall" style={styles.title}>
						{title}
					</Text>
				</Box>
			) : null}
			<Box
				paddingHorizontal={enableGutters ? 16 : 0}
				paddingVertical={enableGutters ? 12 : 0}
			>
				{children}
			</Box>
		</Box>
	);
};

const styles = StyleSheet.create({
	title: {
		textTransform: "uppercase",
	},
});
